export const area = [
    {
        label: '签收区',
        value: 0
    },
    {
        label: '质检区',
        value: 1
    },
    {
        label: '成品区',
        value: 2
    },
    {
        label: '异常区',
        value: 3
    },
    {
        label: '废弃区',
        value: 4
    },
]